// src/assets/icons/CustomIconsAdd3.js

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

// --- CLIPS ICON ---
export const ClipsIcon = (props) => (
  <SvgIcon {...props} viewBox='0 0 6.35 6.35'>
    <ellipse
      cx='3.2006'
      cy='3.1626'
      rx='3.0146'
      ry='3.0272'
      fill='#fff'
      stroke='#000'
      strokeWidth='.22767'
    />
    <circle
      cx='3.0313'
      cy='4.9241'
      r='0'
      fill='#faff46'
      stroke='#000'
      strokeWidth='.26458'
    />

    {/* Group 1: Main Purple Block */}
    <g transform='translate(-.95085 -.90951)'>
      <g transform='translate(.55397 1.017)'>
        <rect
          x='1.0039'
          y='1.2965'
          width='3.7082'
          height='3.3156'
          rx='0'
          ry='0'
          fill='#27007e'
          stroke='#000'
          strokeWidth='.0028359'
        />

        {/* Inner Detail 1 */}
        <g transform='translate(1.823 .58319)'>
          <rect
            x='-.68393'
            y='1.6637'
            width='.43486'
            height='.58075'
            rx='.13853'
            ry='.1216'
            fill='#fff'
            stroke='#000'
            strokeWidth='.0039688'
          />
          <path
            d='m-0.68225 2.0106 0.34878-0.33649'
            fill='none'
            stroke='#000'
            strokeWidth='.0026904'
          />
          <g transform='translate(-1.8188 -.57177)' strokeWidth='.0026458'>
            <path
              d='m1.5713 2.4842-0.26159-0.25091'
              fill='none'
              stroke='#000'
              strokeWidth='.0026458'
            />
          </g>
          <g fill='none' stroke='#000'>
            <path d='m-0.40785 2.2431-0.27492-0.25583' strokeWidth='.0026458' />
            <path d='m-0.25197 2.1547-0.42408-0.40513' strokeWidth='.0026061' />
            <path d='m-0.62352 2.222 0.37446-0.35947' strokeWidth='.0026458' />
            <path d='m-0.38886 2.2455 0.13992-0.13107' strokeWidth='.0026458' />
          </g>
        </g>

        {/* Inner Detail 2 */}
        <g transform='translate(1.8334 1.4252)'>
          <rect
            x='-.68393'
            y='1.6637'
            width='.43486'
            height='.58075'
            rx='.13853'
            ry='.1216'
            fill='#fff'
            stroke='#000'
            strokeWidth='.0039688'
          />
          <path
            d='m-0.68225 2.0106 0.34878-0.33649'
            fill='none'
            stroke='#000'
            strokeWidth='.0026904'
          />
          <g transform='translate(-1.8188 -.57177)' strokeWidth='.0026458'>
            <path
              d='m1.5713 2.4842-0.26159-0.25091'
              fill='none'
              stroke='#000'
              strokeWidth='.0026458'
            />
          </g>
          <g fill='none' stroke='#000'>
            <path d='m-0.40785 2.2431-0.27492-0.25583' strokeWidth='.0026458' />
            <path d='m-0.25197 2.1547-0.42408-0.40513' strokeWidth='.0026061' />
            <path d='m-0.62352 2.222 0.37446-0.35947' strokeWidth='.0026458' />
            <path d='m-0.38886 2.2455 0.13992-0.13107' strokeWidth='.0026458' />
          </g>
        </g>

        {/* Inner Detail 3 */}
        <g transform='translate(1.8393 2.2848)'>
          <rect
            x='-.68393'
            y='1.6637'
            width='.43486'
            height='.58075'
            rx='.13853'
            ry='.1216'
            fill='#fff'
            stroke='#000'
            strokeWidth='.0039688'
          />
          <path
            d='m-0.68225 2.0106 0.34878-0.33649'
            fill='none'
            stroke='#000'
            strokeWidth='.0026904'
          />
          <g transform='translate(-1.8188 -.57177)' strokeWidth='.0026458'>
            <path
              d='m1.5713 2.4842-0.26159-0.25091'
              fill='none'
              stroke='#000'
              strokeWidth='.0026458'
            />
          </g>
          <g fill='none' stroke='#000'>
            <path d='m-0.40785 2.2431-0.27492-0.25583' strokeWidth='.0026458' />
            <path d='m-0.25197 2.1547-0.42408-0.40513' strokeWidth='.0026061' />
            <path d='m-0.62352 2.222 0.37446-0.35947' strokeWidth='.0026458' />
            <path d='m-0.38886 2.2455 0.13992-0.13107' strokeWidth='.0026458' />
          </g>
        </g>

        {/* Inner Detail 4 */}
        <g transform='translate(1.8349 -.29654)'>
          <rect
            x='-.68393'
            y='1.6637'
            width='.43486'
            height='.58075'
            rx='.13853'
            ry='.1216'
            fill='#fff'
            stroke='#000'
            strokeWidth='.0039688'
          />
          <path
            d='m-0.68225 2.0106 0.34878-0.33649'
            fill='none'
            stroke='#000'
            strokeWidth='.0026904'
          />
          <g transform='translate(-1.8188 -.57177)' strokeWidth='.0026458'>
            <path
              d='m1.5713 2.4842-0.26159-0.25091'
              fill='none'
              stroke='#000'
              strokeWidth='.0026458'
            />
          </g>
          <g fill='none' stroke='#000'>
            <path d='m-0.40785 2.2431-0.27492-0.25583' strokeWidth='.0026458' />
            <path d='m-0.25197 2.1547-0.42408-0.40513' strokeWidth='.0026061' />
            <path d='m-0.62352 2.222 0.37446-0.35947' strokeWidth='.0026458' />
            <path d='m-0.38886 2.2455 0.13992-0.13107' strokeWidth='.0026458' />
          </g>
        </g>

        {/* Inner Detail 5 */}
        <g transform='translate(4.833 1.418)'>
          <rect
            x='-.68393'
            y='1.6637'
            width='.43486'
            height='.58075'
            rx='.13853'
            ry='.1216'
            fill='#fff'
            stroke='#000'
            strokeWidth='.0039688'
          />
          <path
            d='m-0.68225 2.0106 0.34878-0.33649'
            fill='none'
            stroke='#000'
            strokeWidth='.0026904'
          />
          <g transform='translate(-1.8188 -.57177)' strokeWidth='.0026458'>
            <path
              d='m1.5713 2.4842-0.26159-0.25091'
              fill='none'
              stroke='#000'
              strokeWidth='.0026458'
            />
          </g>
          <g fill='none' stroke='#000'>
            <path d='m-0.40785 2.2431-0.27492-0.25583' strokeWidth='.0026458' />
            <path d='m-0.25197 2.1547-0.42408-0.40513' strokeWidth='.0026061' />
            <path d='m-0.62352 2.222 0.37446-0.35947' strokeWidth='.0026458' />
            <path d='m-0.38886 2.2455 0.13992-0.13107' strokeWidth='.0026458' />
          </g>
        </g>

        {/* Inner Detail 6 */}
        <g transform='translate(4.8315 2.2906)'>
          <rect
            x='-.68393'
            y='1.6637'
            width='.43486'
            height='.58075'
            rx='.13853'
            ry='.1216'
            fill='#fff'
            stroke='#000'
            strokeWidth='.0039688'
          />
          <path
            d='m-0.68225 2.0106 0.34878-0.33649'
            fill='none'
            stroke='#000'
            strokeWidth='.0026904'
          />
          <g transform='translate(-1.8188 -.57177)' strokeWidth='.0026458'>
            <path
              d='m1.5713 2.4842-0.26159-0.25091'
              fill='none'
              stroke='#000'
              strokeWidth='.0026458'
            />
          </g>
          <g fill='none' stroke='#000'>
            <path d='m-0.40785 2.2431-0.27492-0.25583' strokeWidth='.0026458' />
            <path d='m-0.25197 2.1547-0.42408-0.40513' strokeWidth='.0026061' />
            <path d='m-0.62352 2.222 0.37446-0.35947' strokeWidth='.0026458' />
            <path d='m-0.38886 2.2455 0.13992-0.13107' strokeWidth='.0026458' />
          </g>
        </g>
      </g>
      <rect
        x='2.2853'
        y='2.7963'
        width='2.2725'
        height='2.3004'
        rx='.33775'
        ry='.40039'
        fill='#1aadb7'
        stroke='#000'
        strokeWidth='.0025755'
      />
    </g>

    {/* Group 2: Yellow Elements */}
    <g transform='matrix(1.0739 0 0 1.0739 -.02957 -.45417)'>
      <rect
        x='2.4673'
        y='.6828'
        width='3.1096'
        height='2.4125'
        rx='.1966'
        ry='.17474'
        fill='#fff45e'
        stroke='#000'
        strokeWidth='.025803'
      />
      <g transform='translate(-.069707 -.013941)' fill='#ffa85e'>
        <path
          transform='matrix(.85981 -.48618 .51166 .81699 -1.3665 2.5061)'
          d='m4.446 1.9018 0.00931 0.75123a0.22914 0.22914 149.29 0 1-0.34121 0.20268l-0.65524-0.36755a0.22914 0.22914 89.29 0 1-0.00492-0.39684l0.64593-0.38368a0.22914 0.22914 29.29 0 1 0.34614 0.19416z'
        />
        <path
          transform='matrix(1.4016 -.68376 .83409 1.149 -3.063 2.3406)'
          d='m4.4441 1.7487 0.013109 1.0573a0.14076 0.14076 149.29 0 1-0.20962 0.12451l-0.92223-0.51731a0.14076 0.14076 89.29 0 1-0.00302-0.24379l0.90912-0.54002a0.14076 0.14076 29.29 0 1 0.21264 0.11928z'
        />
        <ellipse cx='3.0079' cy='1.2303' rx='.26489' ry='.26837' />
      </g>
    </g>

    {/* Group 3: Blue Elements & Text - Updated with new Sound Wave SVG logic */}
    <g transform='matrix(.79623 0 0 .77343 -1.1505 2.7217)' stroke='#000'>
      <rect
        x='4.7875'
        y='.62098'
        width='4.2267'
        height='3.4655'
        rx='.237'
        ry='0'
        fill='#fff'
        strokeWidth='.026458'
      />
      <g transform='matrix(.67209 0 0 .62186 4.8641 .29855)'>
        <g stroke='#000'>
          <rect
            x='.83891'
            y='2.6125'
            width='.27786'
            height='1.2755'
            rx='.15693'
            ry='.13757'
            strokeWidth='.0032304'
          />
          <g fill='#332dff'>
            <rect
              x='1.3906'
              y='1.8519'
              width='.27627'
              height='2.8574'
              rx='.15603'
              ry='.17868'
              strokeWidth='.0048212'
            />
            <rect
              x='2.4716'
              y='2.3574'
              width='.27725'
              height='1.8054'
              rx='.15659'
              ry='.11213'
              strokeWidth='.003839'
            />
            <rect
              x='3.5515'
              y='.91626'
              width='.27491'
              height='4.7088'
              rx='.15527'
              ry='.2039'
              strokeWidth='.0061739'
            />
            <rect
              x='4.6521'
              y='1.9845'
              width='.27627'
              height='2.8574'
              rx='.15603'
              ry='.13909'
              strokeWidth='.0048212'
            />
          </g>
          <rect
            x='1.9182'
            y='1.4259'
            width='.27561'
            height='3.6961'
            rx='.15566'
            ry='.19179'
            strokeWidth='.0054768'
          />
          <rect
            x='3.0256'
            y='1.8406'
            width='.27629'
            height='2.8258'
            rx='.15605'
            ry='.14935'
            strokeWidth='.0047947'
          />
          <rect
            x='4.1011'
            y='1.8406'
            width='.27631'
            height='2.8021'
            rx='.15606'
            ry='.17684'
            strokeWidth='.0047747'
          />
          <rect
            x='5.2002'
            y='2.592'
            width='.27786'
            height='1.2755'
            rx='.15693'
            ry='.13757'
            strokeWidth='.0032304'
          />
        </g>
        <circle
          cx='3.1687'
          cy='3.2597'
          r='.91386'
          fill='#fff'
          fillOpacity='.41855'
          stroke='#e6ae4e'
          strokeWidth='0'
        />
        <circle
          cx='3.18'
          cy='3.2565'
          r='.83587'
          fill='#fff'
          fillOpacity='.41855'
          stroke='#ff7910'
          strokeWidth='.11271'
        />
        <path
          d='m3.742 3.2323-0.91751 0.5297v-1.0594z'
          fill='#f07100'
          fillOpacity='.78733'
          stroke='#000'
          strokeWidth='.0032086'
        />
      </g>
    </g>
  </SvgIcon>
);

// --- SOUND WAVE ICON ---
export const SoundWaveIcon = (props) => (
  <SvgIcon {...props} viewBox='0 0 6.35 6.35'>
    <g stroke='#000'>
      <rect
        x='.83891'
        y='2.6125'
        width='.27786'
        height='1.2755'
        rx='.15693'
        ry='.13757'
        strokeWidth='.0032304'
      />
      <g fill='#332dff'>
        <rect
          x='1.3906'
          y='1.8519'
          width='.27627'
          height='2.8574'
          rx='.15603'
          ry='.17868'
          strokeWidth='.0048212'
        />
        <rect
          x='2.4716'
          y='2.3574'
          width='.27725'
          height='1.8054'
          rx='.15659'
          ry='.11213'
          strokeWidth='.003839'
        />
        <rect
          x='3.5515'
          y='.91626'
          width='.27491'
          height='4.7088'
          rx='.15527'
          ry='.2039'
          strokeWidth='.0061739'
        />
        <rect
          x='4.6521'
          y='1.9845'
          width='.27627'
          height='2.8574'
          rx='.15603'
          ry='.13909'
          strokeWidth='.0048212'
        />
      </g>
      <rect
        x='1.9182'
        y='1.4259'
        width='.27561'
        height='3.6961'
        rx='.15566'
        ry='.19179'
        strokeWidth='.0054768'
      />
      <rect
        x='3.0256'
        y='1.8406'
        width='.27629'
        height='2.8258'
        rx='.15605'
        ry='.14935'
        strokeWidth='.0047947'
      />
      <rect
        x='4.1011'
        y='1.8406'
        width='.27631'
        height='2.8021'
        rx='.15606'
        ry='.17684'
        strokeWidth='.0047747'
      />
      <rect
        x='5.2002'
        y='2.592'
        width='.27786'
        height='1.2755'
        rx='.15693'
        ry='.13757'
        strokeWidth='.0032304'
      />
    </g>
    <circle
      cx='3.1687'
      cy='3.2597'
      r='.91386'
      fill='#fff'
      fillOpacity='.41855'
      stroke='#e6ae4e'
      strokeWidth='0'
    />
    <circle
      cx='3.18'
      cy='3.2565'
      r='.83587'
      fill='#fff'
      fillOpacity='.41855'
      stroke='#ff7910'
      strokeWidth='.11271'
    />
    <path
      d='m3.742 3.2323-0.91751 0.5297v-1.0594z'
      fill='#f07100'
      fillOpacity='.78733'
      stroke='#000'
      strokeWidth='.0032086'
    />
  </SvgIcon>
);

export const CLIPS_ICON_SVG_STRING = `<svg width="24" height="24" version="1.1" viewBox="0 0 6.35 6.35" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><ellipse cx="3.2006" cy="3.1626" rx="3.0146" ry="3.0272" fill="#fff" stroke="#000" stroke-width=".22767"/><circle cx="3.0313" cy="4.9241" r="0" fill="#faff46" stroke="#000" stroke-width=".26458"/><g transform="translate(-.95085 -.90951)"><g transform="translate(.55397 1.017)"><rect x="1.0039" y="1.2965" width="3.7082" height="3.3156" rx="0" ry="0" fill="#27007e" stroke="#000" stroke-width=".0028359"/><g transform="translate(1.823 .58319)"><rect x="-.68393" y="1.6637" width=".43486" height=".58075" rx=".13853" ry=".1216" fill="#fff" stroke="#000" stroke-width=".0039688"/><path d="m-0.68225 2.0106 0.34878-0.33649" fill="none" stroke="#000" stroke-width=".0026904"/><g transform="translate(-1.8188 -.57177)" stroke-width=".0026458"><path d="m1.5713 2.4842-0.26159-0.25091" fill="none" stroke="#000" stroke-width=".0026458"/></g><g fill="none" stroke="#000"><path d="m-0.40785 2.2431-0.27492-0.25583" stroke-width=".0026458"/><path d="m-0.25197 2.1547-0.42408-0.40513" stroke-width=".0026061"/><path d="m-0.62352 2.222 0.37446-0.35947" stroke-width=".0026458"/><path d="m-0.38886 2.2455 0.13992-0.13107" stroke-width=".0026458"/></g></g><g transform="translate(1.8334 1.4252)"><rect x="-.68393" y="1.6637" width=".43486" height=".58075" rx=".13853" ry=".1216" fill="#fff" stroke="#000" stroke-width=".0039688"/><path d="m-0.68225 2.0106 0.34878-0.33649" fill="none" stroke="#000" stroke-width=".0026904"/><g transform="translate(-1.8188 -.57177)" stroke-width=".0026458"><path d="m1.5713 2.4842-0.26159-0.25091" fill="none" stroke="#000" stroke-width=".0026458"/></g><g fill="none" stroke="#000"><path d="m-0.40785 2.2431-0.27492-0.25583" stroke-width=".0026458"/><path d="m-0.25197 2.1547-0.42408-0.40513" stroke-width=".0026061"/><path d="m-0.62352 2.222 0.37446-0.35947" stroke-width=".0026458"/><path d="m-0.38886 2.2455 0.13992-0.13107" stroke-width=".0026458"/></g></g><g transform="translate(1.8393 2.2848)"><rect x="-.68393" y="1.6637" width=".43486" height=".58075" rx=".13853" ry=".1216" fill="#fff" stroke="#000" stroke-width=".0039688"/><path d="m-0.68225 2.0106 0.34878-0.33649" fill="none" stroke="#000" stroke-width=".0026904"/><g transform="translate(-1.8188 -.57177)" stroke-width=".0026458"><path d="m1.5713 2.4842-0.26159-0.25091" fill="none" stroke="#000" stroke-width=".0026458"/></g><g fill="none" stroke="#000"><path d="m-0.40785 2.2431-0.27492-0.25583" stroke-width=".0026458"/><path d="m-0.25197 2.1547-0.42408-0.40513" stroke-width=".0026061"/><path d="m-0.62352 2.222 0.37446-0.35947" stroke-width=".0026458"/><path d="m-0.38886 2.2455 0.13992-0.13107" stroke-width=".0026458"/></g></g><g transform="translate(1.8349 -.29654)"><rect x="-.68393" y="1.6637" width=".43486" height=".58075" rx=".13853" ry=".1216" fill="#fff" stroke="#000" stroke-width=".0039688"/><path d="m-0.68225 2.0106 0.34878-0.33649" fill="none" stroke="#000" stroke-width=".0026904"/><g transform="translate(-1.8188 -.57177)" stroke-width=".0026458"><path d="m1.5713 2.4842-0.26159-0.25091" fill="none" stroke="#000" stroke-width=".0026458"/></g><g fill="none" stroke="#000"><path d="m-0.40785 2.2431-0.27492-0.25583" stroke-width=".0026458"/><path d="m-0.25197 2.1547-0.42408-0.40513" stroke-width=".0026061"/><path d="m-0.62352 2.222 0.37446-0.35947" stroke-width=".0026458"/><path d="m-0.38886 2.2455 0.13992-0.13107" stroke-width=".0026458"/></g></g><g transform="translate(4.833 1.418)"><rect x="-.68393" y="1.6637" width=".43486" height=".58075" rx=".13853" ry=".1216" fill="#fff" stroke="#000" stroke-width=".0039688"/><path d="m-0.68225 2.0106 0.34878-0.33649" fill="none" stroke="#000" stroke-width=".0026904"/><g transform="translate(-1.8188 -.57177)" stroke-width=".0026458"><path d="m1.5713 2.4842-0.26159-0.25091" fill="none" stroke="#000" stroke-width=".0026458"/></g><g fill="none" stroke="#000"><path d="m-0.40785 2.2431-0.27492-0.25583" stroke-width=".0026458"/><path d="m-0.25197 2.1547-0.42408-0.40513" stroke-width=".0026061"/><path d="m-0.62352 2.222 0.37446-0.35947" stroke-width=".0026458"/><path d="m-0.38886 2.2455 0.13992-0.13107" stroke-width=".0026458"/></g></g><g transform="translate(4.8315 2.2906)"><rect x="-.68393" y="1.6637" width=".43486" height=".58075" rx=".13853" ry=".1216" fill="#fff" stroke="#000" stroke-width=".0039688"/><path d="m-0.68225 2.0106 0.34878-0.33649" fill="none" stroke="#000" stroke-width=".0026904"/><g transform="translate(-1.8188 -.57177)" stroke-width=".0026458"><path d="m1.5713 2.4842-0.26159-0.25091" fill="none" stroke="#000" stroke-width=".0026458"/></g><g fill="none" stroke="#000"><path d="m-0.40785 2.2431-0.27492-0.25583" stroke-width=".0026458"/><path d="m-0.25197 2.1547-0.42408-0.40513" stroke-width=".0026061"/><path d="m-0.62352 2.222 0.37446-0.35947" stroke-width=".0026458"/><path d="m-0.38886 2.2455 0.13992-0.13107" stroke-width=".0026458"/></g></g></g><rect x="2.2853" y="2.7963" width="2.2725" height="2.3004" rx=".33775" ry=".40039" fill="#1aadb7" stroke="#000" stroke-width=".0025755"/></g><g transform="matrix(1.0739 0 0 1.0739 -.02957 -.45417)"><rect x="2.4673" y=".6828" width="3.1096" height="2.4125" rx=".1966" ry=".17474" fill="#fff45e" stroke="#000" stroke-width=".025803"/><g transform="translate(-.069707 -.013941)" fill="#ffa85e"><path transform="matrix(.85981 -.48618 .51166 .81699 -1.3665 2.5061)" d="m4.446 1.9018 0.00931 0.75123a0.22914 0.22914 149.29 0 1-0.34121 0.20268l-0.65524-0.36755a0.22914 0.22914 89.29 0 1-0.00492-0.39684l0.64593-0.38368a0.22914 0.22914 29.29 0 1 0.34614 0.19416z"/><path transform="matrix(1.4016 -.68376 .83409 1.149 -3.063 2.3406)" d="m4.4441 1.7487 0.013109 1.0573a0.14076 0.14076 149.29 0 1-0.20962 0.12451l-0.92223-0.51731a0.14076 0.14076 89.29 0 1-0.00302-0.24379l0.90912-0.54002a0.14076 0.14076 29.29 0 1 0.21264 0.11928z"/><ellipse cx="3.0079" cy="1.2303" rx=".26489" ry=".26837"/></g></g><g transform="matrix(.79623 0 0 .77343 -1.1505 2.7217)" stroke="#000"><rect x="4.7875" y=".62098" width="4.2267" height="3.4655" rx=".237" ry="0" fill="#fff" stroke-width=".026458"/><g transform="matrix(.67209 0 0 .62186 4.8641 .29855)"><g stroke="#000"><rect x=".83891" y="2.6125" width=".27786" height="1.2755" rx=".15693" ry=".13757" stroke-width=".0032304"/><g fill="#332dff"><rect x="1.3906" y="1.8519" width=".27627" height="2.8574" rx=".15603" ry=".17868" stroke-width=".0048212"/><rect x="2.4716" y="2.3574" width=".27725" height="1.8054" rx=".15659" ry=".11213" stroke-width=".003839"/><rect x="3.5515" y=".91626" width=".27491" height="4.7088" rx=".15527" ry=".2039" stroke-width=".0061739"/><rect x="4.6521" y="1.9845" width=".27627" height="2.8574" rx=".15603" ry=".13909" stroke-width=".0048212"/></g><rect x="1.9182" y="1.4259" width=".27561" height="3.6961" rx=".15566" ry=".19179" stroke-width=".0054768"/><rect x="3.0256" y="1.8406" width=".27629" height="2.8258" rx=".15605" ry=".14935" stroke-width=".0047947"/><rect x="4.1011" y="1.8406" width=".27631" height="2.8021" rx=".15606" ry=".17684" stroke-width=".0047747"/><rect x="5.2002" y="2.592" width=".27786" height="1.2755" rx=".15693" ry=".13757" stroke-width=".0032304"/></g><circle cx="3.1687" cy="3.2597" r=".91386" fill="#fff" fill-opacity=".41855" stroke="#e6ae4e" stroke-width="0"/><circle cx="3.18" cy="3.2565" r=".83587" fill="#fff" fill-opacity=".41855" stroke="#ff7910" stroke-width=".11271"/><path d="m3.742 3.2323-0.91751 0.5297v-1.0594z" fill="#f07100" fill-opacity=".78733" stroke="#000" stroke-width=".0032086"/></g></g></svg>`;

export const SOUND_WAVE_ICON_SVG_STRING = `<svg width="24" height="24" version="1.1" viewBox="0 0 6.35 6.35" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><g stroke="#000"><rect x=".83891" y="2.6125" width=".27786" height="1.2755" rx=".15693" ry=".13757" stroke-width=".0032304"/><g fill="#332dff"><rect x="1.3906" y="1.8519" width=".27627" height="2.8574" rx=".15603" ry=".17868" stroke-width=".0048212"/><rect x="2.4716" y="2.3574" width=".27725" height="1.8054" rx=".15659" ry=".11213" stroke-width=".003839"/><rect x="3.5515" y=".91626" width=".27491" height="4.7088" rx=".15527" ry=".2039" stroke-width=".0061739"/><rect x="4.6521" y="1.9845" width=".27627" height="2.8574" rx=".15603" ry=".13909" stroke-width=".0048212"/></g><rect x="1.9182" y="1.4259" width=".27561" height="3.6961" rx=".15566" ry=".19179" stroke-width=".0054768"/><rect x="3.0256" y="1.8406" width=".27629" height="2.8258" rx=".15605" ry=".14935" stroke-width=".0047947"/><rect x="4.1011" y="1.8406" width=".27631" height="2.8021" rx=".15606" ry=".17684" stroke-width=".0047747"/><rect x="5.2002" y="2.592" width=".27786" height="1.2755" rx=".15693" ry=".13757" stroke-width=".0032304"/></g><circle cx="3.1687" cy="3.2597" r=".91386" fill="#fff" fill-opacity=".41855" stroke="#e6ae4e" stroke-width="0"/><circle cx="3.18" cy="3.2565" r=".83587" fill="#fff" fill-opacity=".41855" stroke="#ff7910" stroke-width=".11271"/><path d="m3.742 3.2323-0.91751 0.5297v-1.0594z" fill="#f07100" fill-opacity=".78733" stroke="#000" stroke-width=".0032086"/></svg>`;
